import { useMutation, useQueryClient } from '@tanstack/react-query';
import { retentionAdminApi } from '../api/retentionAdminApi';
import type { CreateRetentionPolicyRequest } from '../types/retentionAdmin';

/**
 * POST /api/eraf/retention-admin/policies — 보존 정책 생성 (RETENTION_MANAGE)
 */
export function useCreatePolicy() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateRetentionPolicyRequest) => retentionAdminApi.createPolicy(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['retention-admin', 'list'] });
    },
  });
}
